import { useEffect, useState } from "react";
import { _DocumentFactory, _IndirectCostType, _ProductionOrder, _ProductiveProcessType, _single } from "../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { AccountEditor } from "../../editor/AccountEditor";
import usePaginator from "../../theme/Component/usePaginator";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { SelectProject } from "../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { SelectManufacturingStandars } from "../ManufacturingStandars/SelectManufacturingStandars";
import { SelectAttentionOffice } from "./Components/SelectAttentionOffice";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { SelectProductionOrderStateConstants } from "./Components/SelectProductionOrderStateConstants";
import { InputDate } from "../../theme/Input/InputDate";
import { BasicButton } from "../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { SelectProductionOrderRequestConstants } from "./Components/SelectProductionOrderRequestConstants";
import { SelectBusinessCore } from "../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectProductEditor } from "../ManufacturingStandars/Components/SelectProductEditor";
import { ManufacturingStandarsEditor } from "../ManufacturingStandars/ManufacturingStandarsEditor";
import { SelectProductVariant } from "../../Inventories-Warehouses/Product/ProductVariant/SelectProductVariant";
import { ProductionOrderRemission } from "./ProductionOrderRemission";
import { SelectProductionRoute } from "../ProductionRoute/SelectProductionRoute";
import { _ApplyProductionPlan, _AssingExternal, _ExportProductionOrders, _liquidateProduction, _MaterialAdjustment, _ProductionOrderStandardImp, _ProductionOrderTicket, _RawMaterialClose, _ReleaseProdOrder, _ReleaseProdOrderExternal, _TimeEventStandard, _UpdateStandardCostsImp } from "../../../core/services/dataBean/EntityCatalogVdos";
import { RawMaterialRequestCatalog } from "./RawMaterialRequestCatalog/RawMaterialRequestCatalog";
import { MaterialAvailableProductionOrder } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/MaterialAvailableProductionOrder";
import { CostProductionOrderCatalog } from "./getCostProductionOrderCatalog/CostProductionOrderCatalog";
import { TraslateProdcutProccesFinished } from "./RawMaterialRequestCatalog/TraslateProdcutProccesFinished/TraslateProdcutProccesFinished";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";
import { OrderToWIP } from "./OrderToWIP/OrderToWIP";
import { ProductionOrderDocuments } from "./ProductionOrderDocuments/ProductionOrderDocuments";
import { ProductLotCatalog } from "../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/ProductLotCatalog";
import { TimeMovements } from "./Components/TimeMovements/TimeMovements";
import { ProductionPlanEditor } from "../../Talentohumano/GestionTH/EmployeeContract/ProductionPlan/ProductionPlanEditor";
import { ExternalFactoryEditor } from "./ExternalFactory/ExternalFactoryEditor";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { ProductionOrderEvent } from "./Components/ProductionOrderEvent/ProductionOrderEvent";

interface Props {
    isModal?: boolean;
    onChange?: Function;
}

type propsForms = {
    Observations: string;
    FromDate: any;
    UptoDate: any;
}

export const ProductionOrder = ({ isModal, onChange }: Props) => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_ProductionOrder);
    const _documentos = useDataBean(_DocumentFactory);
    const updateestandarimp = useDataBean(_UpdateStandardCostsImp);
    const prod = useDataBean(_ProductionOrder);
    const applyprod = useDataBean(_ApplyProductionPlan);
    const releaseprodorder = useDataBean(_ReleaseProdOrder);
    const releaseprodorderexternal = useDataBean(_ReleaseProdOrderExternal);
    const exportproduction = useDataBean(_ExportProductionOrders);
    const assingexternal = useDataBean(_AssingExternal);
    const generateticket = useDataBean(_ProductionOrderTicket);
    const TimeEventStandard = useDataBean(_TimeEventStandard);
    const standardproduction = useDataBean(_ProductionOrderStandardImp);
    const Ajustar = useDataBean(_MaterialAdjustment);
    const Devolucion = useDataBean(_RawMaterialClose);
    const liquidar = useDataBean(_liquidateProduction);


    const paginador = usePaginator();
    const [date, setDate] = useState<any>(null)
    const [exportxsl, setexportxsl] = useState<number>(null)
    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        Year: _single.getCurrenYear(),
        MonthVigency: NaN,
        FromDate: null,
        UptoDate: null,
        IDProject: NaN,
        IDManufacturingStandart: NaN,
        IDAttentionOffice: NaN,
        IDStore: NaN,
        State: NaN,
    })
    const [formato, setFormato] = useState<any>([]);
    const [formatoticket, setFormatoticket] = useState<any>([]);
    const [formatodos, setFormatodos] = useState<any>([]);
    const [formatotres, setFormatotres] = useState<any>([]);
    const [obs, setObs] = useState<string>("")
    const [docs, setDocs] = useState<any>([]);
    const [docsliquidation, setDocsliquidation] = useState<any>([]);
    const [docsvdos, setDocsvdos] = useState<any>([]);
    const [docsvtres, setDocsvtres] = useState<any>([]);
    const [docsvcinco, setDocsvcinco] = useState<any>([]);
    const [formControl, setFormControl] = useState<Partial<propsForms>>({});

    const modalCancel = useModal(`Cancelar Orden de Producción`, MODAL_md);
    const modalNullify = useModal(`Anular Orden de Producción`, MODAL_md);
    const modalUpdateDates = useModal(`Actualizar Fechas Reales`, MODAL_md);
    const modalEvents = useModal(`Eventos de la Orden de Producción`, MODAL_LG);

    const [modalupdateestand, setModalupdateestand] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldeleteplan, setModaldeleteplan] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldeleteexternal, setModaldeleteexternal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaladdplan, setModaladdplan] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalmaquila, setModalmaquila] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [costeoestandard, setCosteoestandard] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalticket, setModalticket] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaltime, setModaltime] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modallotes, setModallotes] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdocs, setModalverdocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [standardsdocs, setStandardsdocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalregister, setModalregister] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [ajustardocs, setajustardocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [devoluciondocs, setdevoluciondocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [liquidardocs, setliquidardocs] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalajustar, setModalajustar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldevolucion, setModaldevolucion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalliquidar, setModalliquidar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalDocliquidar, setModalDocliquidar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaltrasladoprocces, setModaltrasladoprocces] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcost, setModalcost] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [inventory, setInventory] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [consultar, setConsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [exportproductionordenbyaccion, setexportproductionordenbyaccion] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-md' });
    const [exportexel, setexportexel] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [reporte, setDescargarreporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [finalizarorden, setFinalizarorden] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [detenerorden, setDetenerorden] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [ejecutarorden, setEjecutarorden] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [traslados, setTraslados] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (modalDocliquidar.view) {
            verDocumentosliquidacion();
        }
    }, [modalDocliquidar.view]);
    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
        setLista([])
        instance.getProductionOrderCatalog(form.IDAccount, form.IDProduct ?? null, form.Code ?? null, form.Year, form.MonthVigency ?? null, form.FromDate, form.UptoDate, form.IDProject, form.IDManufacturingStandart, form.IDAttentionOffice, form.IDStore, form.State, paginador.page, 15).then(
            (resp) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    const x = resp.List.map(element => {
                        element.DataBeanProperties.EntityUnit = element.DataBeanProperties.MeasurementUnitCode ? `${element.DataBeanProperties.MeasurementUnitCode} - ${element.DataBeanProperties.MeasurementUnitName}` : "N/A"
                        element.DataBeanProperties.DocLiquidation = element.DataBeanProperties.Mnemonic ? `${element.DataBeanProperties.Consecutive} - ${element.DataBeanProperties.DocumentDate}` : "Sin Documento"
                        return element;
                    });
                    setLista(x);
                } else {
                    setLista([]);
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const editaItem = () => {
        instance.updateProductionOrder(bean).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        prod.instance.deleteProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDProductionOrder', visible: true },
        { title: 'Código Orden de Producción', property: 'Code', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha de la Orden de Producción', property: 'ProductionOrderDate', visible: true },
        { title: 'Centro de Fabricación', property: 'AttentionOfficeName', visible: true },
        { title: 'Fecha Inicio', property: 'InitDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Fin', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Inicio Real', property: 'RealInitDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Finalización Real', property: 'RealUptoDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Evento Finalización', property: 'ProductionFinishedDate', visible: true, mask: MASK_DATE },
        { title: 'Tipo de Solicitud', property: 'TypeName', visible: true },
        { title: 'No Solicitud Cliente', property: 'ExternalRequestReference', visible: true },
        { title: 'Cliente/Solicitante', property: 'ContractName', visible: true },
        { title: 'Estandard de Fabricación', property: 'ManufacturingStardardName', visible: true },
        { title: 'Producto a Producir', property: 'ProductName', visible: true },
        { title: 'Variante/Talla', property: 'ProductVariantName', visible: true },
        { title: 'Unidad de Medida', property: "EntityUnit", visible: true },
        { title: 'Usar Maquila Externa', property: "UseExternalFactory", visible: true },
        { title: 'Maquila/CentroExterno', property: "ExternalFactoryName", visible: true },
        { title: 'Plan de Producción', property: "ProductionPlanName", visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Línea de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Cantidad a Producir', property: 'Quantity', visible: true },
        { title: 'Cantidad de Producto Producido', property: 'FinishedProductQuantity', visible: true },
        { title: 'Cantidad Pendiente por Producir', property: 'PendingQuantity', visible: true },
        { title: 'Costo Producto Producido', property: 'FinishedProductCost', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Estado de la Operación', property: 'OrderStateName', visible: true },
        { title: 'Documento Orden de Producción', property: 'POConsecutive', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
        { title: 'No Solicitud Cliente', property: 'ExternalRequestReference', visible: true },
        { title: 'Ruteo de Producción', property: 'ProductionRouteName', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Document de Liquidación/Cierre', property: 'DocLiquidation', visible: true },
    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Orden de Producción" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const resetObservations = () => {
        setBean(prev => ({ ...prev, Observations: '' }));
    };
    const releaseProductionOrderFromProductionPlan = () => {
        releaseprodorder.instance.releaseProductionOrderFromProductionPlan(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Eliminado del Plan');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const releaseProductionOrderFromExternalFactory = () => {
        releaseprodorderexternal.instance.releaseProductionOrderFromExternalFactory(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Eliminado de Maquila/Centro');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const updateProductionOrderStandardCostsImp = () => {
        updateestandarimp.instance.updateProductionOrderStandardCostsImp(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    setModalupdateestand({ ...modalupdateestand, "view": false });
                    toast.success('Actualizado Costo Estandar');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const listaBotones = () => {
        const botones = [
            { titulo: 'Actualizar Costo Estandard del Estandard', icono: 'ri-file-add-line', visible: true, evento: () => { setModalupdateestand({ ...modalupdateestand, "view": true }) } },
            { titulo: 'Agregar a Plan de Producción', icono: 'ri-file-add-line', visible: true, evento: () => { setModaladdplan({ ...modaladdplan, "view": true }) } },
            { titulo: 'Eliminar de Plan de Producción', icono: 'ri-file-forbid-line', visible: true, evento: () => { setModaldeleteplan({ ...modaldeleteplan, "view": true }) } },
            { titulo: 'Asignar a Maquila/Centro de Fabricación Externo', icono: 'ri-file-transfer-fill', visible: true, evento: () => { setModalmaquila({ ...modalmaquila, "view": true }) } },
            { titulo: 'Eliminar de Maquila/Centro de Fabricación Externo', icono: 'ri-file-forbid-fill', visible: true, evento: () => { setModaldeleteexternal({ ...modaldeleteexternal, "view": true }) } },
            { titulo: 'Ajustar Costos de Material', icono: 'ri-swap-box-fill', visible: true, evento: () => { setModalajustar({ ...modalajustar, "view": true }) } },
            // { titulo: 'Actualizar Estandard de Fabricación', icono: 'bx bx-food-menu', visible: true, evento: () => { updateProductionOrderStandardImp() } },
            { titulo: 'Consultar Solicitudes de Materia Prima', icono: 'ri-file-search-line', visible: true, evento: () => { setConsultar({ ...consultar, "view": true, "name": "Consultar Solicitudes de Materia Prima" }) } },
            { titulo: 'Costos de Orden de Producción', icono: 'ri-refund-2-line', visible: true, evento: () => { setModalcost({ ...modalcost, "view": true }) } },
            {
                titulo: 'Detener Ejecución de Orden de Producción',
                icono: 'ri-file-forbid-line',
                visible: _single.canEdit(),
                evento: () => {
                    resetObservations();
                    setDetenerorden({ ...detenerorden, view: true, name: 'Detener Orden de Producción' });
                }
            },
            // { titulo: 'Exportar a Excel Orden de Producción', icono: 'ri-edit-2-line', visible: true, evento: () => { setFormato({}); setexportproductionordenbyaccion({ ...exportproductionordenbyaccion, "view": true, "name": "Generar Reporte de Orden de Producción" }) } },
            { titulo: 'Exportar a Excel Orden de Producción', icono: 'ri-file-chart-fill', visible: true, evento: () => { exportProductionOrdersbyaccion() } },
            {
                titulo: 'Ejecutar Orden de Producción',
                icono: 'ri-send-plane-fill',
                visible: _single.canEdit(),
                evento: () => {
                    resetObservations();
                    setEjecutarorden({ ...ejecutarorden, view: true, name: 'Ejecutar Orden de Producción' });
                }
            },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Orden de Producción" }) } },
            { titulo: 'Eliminar', icono: 'ri-file-excel-fill', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Orden de Producción` }) } },
            {
                titulo: 'Finalizar Orden de Producción',
                icono: 'ri-file-transfer-line',
                visible: _single.canEdit(),
                evento: () => {
                    resetObservations();
                    setFinalizarorden({ ...finalizarorden, view: true, name: 'Finalizar Orden de Producción' });
                }
            },
            { titulo: 'Generar Reporte de Orden de Producción', icono: ' ri-file-download-line', visible: true, evento: () => { setFormato({}); setDescargarreporte({ ...reporte, "view": true, "name": "Generar Reporte de Orden de Producción" }) } },
            { titulo: 'Generar Ticket de Producción', icono: 'bx bx-bookmark-alt-minus', visible: true, evento: () => { getProductionOrderTicket() } },
            { titulo: 'Generar Contabilización de Costeo Estandard', icono: ' ri-file-download-line', visible: true, evento: () => { setCosteoestandard({ ...costeoestandard, "view": true, "name": "Generar Contabilización de Costeo Estandard" }) } },
            { titulo: 'Inventario Disponible en Orden de Producción', icono: 'ri-file-unknow-fill', visible: true, evento: () => { setInventory({ ...inventory, "view": true }) } },
            { titulo: 'Lotes de Producción', icono: 'bx bx-box', visible: true, evento: () => { setModallotes({ ...modallotes, "view": true }) } },
            { titulo: 'Liquidar Orden de Producción', icono: 'ri-file-damage-line', visible: true, evento: () => { setModalliquidar({ ...modalliquidar, "view": true }) } },
            { titulo: 'Registros de Producto en Proceso', icono: 'ri-list-unordered', visible: true, evento: () => { setModalregister({ ...modalregister, "view": true }) } },
            { titulo: 'Realizar Devolución de Materia Prima a Almacén', icono: 'ri-swap-fill', visible: true, evento: () => { setModaldevolucion({ ...modaldevolucion, "view": true }) } },
            { titulo: 'Tiempos y Movimientos', icono: 'bx bx-sort', visible: true, evento: () => { setModaltime({ ...modaltime, "view": true }) } },
            { titulo: 'Traslados de Producto en Proceso a Producto Terminado', icono: 'ri-line-height', visible: true, evento: () => { setModaltrasladoprocces({ ...modaltrasladoprocces, "view": true }) } },
            { titulo: 'Ver Traslados de Producto Terminado a Remisión/Almacén', icono: 'ri-phone-find-line', visible: _single.canEdit(), evento: () => { setTraslados({ ...traslados, "view": true, "name": "Ver Traslados de Producto Terminado a Almacén" }) } },
            { titulo: 'Ver Documentos de la Orden de Producción', icono: 'ri-swap-box-fill', visible: true, evento: () => { setModalverdocs({ ...modalverdocs, "view": true }) } },
            { titulo: 'Ver Documento de Liquidación', icono: 'bx bxs-file-doc', visible: true, evento: () => { setModalDocliquidar({ ...modalDocliquidar, "view": true }) } },
            { titulo: 'Eventos', icono: 'ri-list-check-2', visible: true, evento: () => { modalEvents.open(); } },
            {
                titulo: 'Cancelar Orden de Producción', icono: 'ri-close-line', visible: true, evento: () => {
                    setFormControl({});
                    modalCancel.open();
                }
            },
            {
                titulo: 'Anular Orden de Producción', icono: 'ri-forbid-2-line', visible: true, evento: () => {
                    setFormControl({});
                    modalNullify.open();
                }
            },
            {
                titulo: 'Fecha de Finalización/cierre de orden proceso logístico', icono: 'ri-exchange-line', visible: true, evento: () => {
                    modalUpdateDates.open();
                    setFormControl({});
                }
            },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const verDocumentosliquidacion = () => {

        if (bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(bean.IDDocument, null, bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    setDocsliquidation(resp.DocumentURL);
                    // setverdocliquidation({ ...verdocliquidation, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado de liquidación");
        }

    }
    const [missingFieldsAdd, setMissingFieldsAdd] = useState<string[]>([]);
    const [missingFieldsForm, setMissingFieldsForm] = useState<string[]>([]);

    const validateAddData = () => {
        if (validataAddForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validataAddForm = () => {
        const requiredFields = [
            "IDAttentionOffice"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFieldsAdd(missing);
        return missing.length;
    };

    const validateForm = () => {
        if (validateDataForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            getLista();
        }
    }
    const abrirexportprodutionorders = () => {
        setexportexel({ ...exportexel, "view": true, "name": "Exportar a Excel" });
    }
    const applyProductionPlanToProductionOrder = () => {
        applyprod.instance.applyProductionPlanToProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, applyprod.bean.IDProductionPlan, applyprod.bean.ProductionPlanDate).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Aplicado');
                    setModaladdplan({ ...modaladdplan, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const assignExternalFactoryToProductionOrder = () => {
        assingexternal.instance.assignExternalFactoryToProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, assingexternal.bean.IDExternalFactory).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Asignado');
                    setModalmaquila({ ...modalmaquila, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const exportProductionOrdersbyaccion = () => {
        exportproduction.instance.exportProductionOrders(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    setFormatotres(resp[0]);
                    setexportproductionordenbyaccion({ ...exportproductionordenbyaccion, "view": true, "name": "Generar Reporte de Orden de Producción" })
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const updateProductionOrderStandardImp = () => {
        standardproduction.instance.updateProductionOrderStandardImp(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Estandard Actualizado');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const exportProductionOrders = () => {
        exportproduction.instance.exportProductionOrdersvdos(date, exportxsl).then(
            (resp: any) => {
                if (resp) {
                    setFormatodos(resp[0]);
                    // setexportexel({ ...exportexel, "view": false, "name": "Exportar a Excel" });
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateDataForm = () => {
        const requiredFields = [
            "Year"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (form[field] === null || form[field] === undefined || form[field] === "" || Number.isNaN(form[field])) {
                missing.push(field);
            }
        }
        setMissingFieldsForm(missing);
        return missing.length;
    };

    const setRowBean = (obj) => {
        setBean(obj)
        if (onChange) {
            onChange(obj)
        }
    }

    const ejecutarlaordendeproduccion = () => {
        instance.postProductionOrderToProductionProcess(
            bean.IDProductionOrder,
            bean.ProductionOrderDate,
            _single.getAccountID(),
            bean.Observations
        ).then((resp: any) => {
            if (resp) {
                resp.MsgList?.forEach((msg: string) => {
                    toast.info(msg);
                });

                setEjecutarorden({ ...ejecutarorden, name: "Ejecutar", view: false });
            }
        }).catch(err => {
            toast.error(err);
        });
    };

    const detenerordendeproduccion = () => {
        instance.rejectProductionOrderToProductionProcess(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID(), obs).then(
            (resp: any) => {
                if (resp) {
                    setDetenerorden({ ...detenerorden, "name": `Detener`, "view": false });
                    setObs("");
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )

    }

    const finalizarordendeproduccion = () => {
        instance.postProductionOrderAsFinished(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID(), obs).then(
            (resp: any) => {
                if (resp) {
                    setObs("");
                    setFinalizarorden({ ...finalizarorden, "name": `Finalizar`, "view": false })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const createRawMaterialAdjustmentForProductionOrder = () => {
        Ajustar.instance.createRawMaterialAdjustmentForProductionOrder(Ajustar.bean.IDStoreDestinity, bean.IDProductionOrder, bean.ProductionOrderDate, Ajustar.bean.AccountantDate, Ajustar.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Ajustado')
                    setDocs(resp.DocumentURL);
                    setModalajustar({ ...modalajustar, "view": false })
                    setajustardocs({ ...ajustardocs, "view": true })

                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const createRawMaterialCloseForProductionOrder = () => {
        Devolucion.instance.createRawMaterialCloseForProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, Devolucion.bean.IDStoreDestinity, Devolucion.bean.AccountantDate, Devolucion.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Devolucion Realizada')
                    setDocsvdos(resp.DocumentURL);
                    setModaldevolucion({ ...modaldevolucion, "view": false })
                    setdevoluciondocs({ ...devoluciondocs, "view": true })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const getProductionOrderTicket = () => {
        generateticket.instance.getProductionOrderTicket(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Tickect Generado')
                    setFormatoticket(resp[0]);
                    setModalticket({ ...modalticket, "view": true })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const liquidateProductionOrder = () => {
        liquidar.instance.liquidateProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, liquidar.bean.IDStoreDestinity, liquidar.bean.AccountantDate, liquidar.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Orden Liquidada')
                    setDocsvtres(resp.DocumentURL);
                    setModalliquidar({ ...modalliquidar, "view": false })
                    setliquidardocs({ ...liquidardocs, "view": true })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const createTimeEventStandardForProductionOrder = () => {
        TimeEventStandard.instance.createTimeEventStandardForProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, TimeEventStandard.bean.AccountantDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Contabilización de Costeo Estandard Exitoso')
                    setDocsvcinco(resp.DocumentURL);
                    setCosteoestandard({ ...costeoestandard, "view": false })
                    setStandardsdocs({ ...standardsdocs, "view": true })
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    useEffect(() => {
        if (reporte.view) {
            descargarreporteproduccion();
        }
    }, [reporte.view]);
    const descargarreporteproduccion = () => {

        instance.getProductionOrderReport(bean.IDProductionOrder, bean.ProductionOrderDate).then(
            (resp: any) => {
                if (resp && resp.length > 0) {
                    setFormato(resp[0]);
                    resp.MsgList?.forEach((msg: string) => {
                        toast.info(msg);
                    });
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )

    }

    const hasValidObservations = () => formControl.Observations?.trim().length >= 15;


    const cancelProductionOrder = () => {
        if (!hasValidObservations()) {
            toast.error("Observaciones deben tener mínimo 15 caracteres");
            return;
        }


        instance.postProductionOrderAsCanceled(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID(), formControl.Observations).then(
            (resp) => {
                modalCancel.close();
                getLista();
                toast.success(`Orden de producción ${bean.IDProductionOrder} Cancelada`)
            }
        ).catch(errr => { toast.error(errr) })
    }

    const nullifyProductionOrder = () => {
        if (!hasValidObservations()) {
            toast.error("Observaciones deben tener mínimo 15 caracteres");
            return;
        }

        instance.postProductionOrderAsNullify(bean.IDProductionOrder, bean.ProductionOrderDate, _single.getAccountID(), formControl.Observations).then(
            (resp) => {
                modalNullify.close();
                getLista();
                toast.success(`Orden de producción ${bean.IDProductionOrder} Anulada`)
            }
        ).catch(errr => { toast.error(errr) })
    }

    const setRealDates = () => {
        if (!formControl.FromDate) {
            toast.error("Fecha inicial no valida")
            return;
        }
        if (!formControl.UptoDate) {
            toast.error("Fecha final no valida")
            return;
        }
        if (!hasValidObservations()) {
            toast.error("Observaciones deben tener mínimo 15 caracteres");
            return;
        }

        instance.setRealDatesToProductionOrder(bean.IDProductionOrder, bean.ProductionOrderDate, formControl.FromDate, formControl.UptoDate, _single.getAccountID(), formControl.Observations).then(
            (resp) => {
                modalUpdateDates.close();
                getLista();
                toast.success("Fechas actualizadas")
            }
        ).catch(errr => { toast.error(errr) })
    }

    const rowContent = (
        <div className="row">
            <div className="col-md-4">
                <AccountEditor idAccount={null} label="Cliente" onChange={(e) => { setForm({ ...form, "IDAccount": e.IDAccount }) }} />
            </div>
            <div className="col-md-4">
                <label className={`${missingFieldsForm.includes('Year') ? 'has-error' : ''}`}>Año/Vigencia</label>
                <YearSelector tittle=" " onChange={(e) => { setForm({ ...form, "Year": e }) }} />
            </div>
            <div className="col-md-4">
                <label className={`${missingFieldsForm.includes('MonthVigency') ? 'has-error' : ''}`}>Mes</label>
                <MonthConstantsEditor idSelect={form.MonthVigency} onChange={(e) => { setForm({ ...form, "MonthVigency": e }) }} label=" " name="" />
            </div>
            <div className="col-md-6">
                <SelectProject idSelector={form.IDProject} onChange={(e) => { setForm({ ...form, "IDProject": e }) }} label="Proyecto" />
            </div>
            <div className="col-md-6">
                <SelectManufacturingStandars idSelector={form.IDManufacturingStandart} onChange={(e) => { setForm({ ...form, "IDManufacturingStandart": e }) }} label="Estandard de Fabricación" />
            </div>
            <div className="col-md-6">
                <SelectAttentionOffice idSelector={form.IDAttentionOffice} onChange={(e) => { setForm({ ...form, "IDAttentionOffice": e }) }} label="Centro de Fabricación" />
            </div>
            <div className="col-md-6">
                <SelectStoreEditor idSelector={form.IDStore} label="" onChange={(e) => { setForm({ ...form, "IDStore": e.IDStore }) }} />
            </div>
            <div className="col-md-6">
                <SelectProductionOrderStateConstants idSelector={form.State} onChange={(e) => { setForm({ ...form, "State": e }) }} label="Estado de la Orden de Producción" />
            </div>
            <div className="col-md-6">
                <SelectProductEditor filterType={3} label="Producto Final" value={form.IDProduct} onChange={(e) => { setForm({ ...form, "IDProduct": e.IDProduct }) }} />
            </div>
            <div className="col-md-6">
                <label >Código de Orden</label>
                <input type="number" className="form-control" value={form.Code} onChange={(e) => { setForm({ ...form, "Code": e.target.value }) }} />
            </div>
            <div className="col-md-6 mt-4">
                <BasicButton eventClick={validateForm} icon="ri-search-line" children={"Buscar"} />
            </div>
            <div className="row">
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={abrirexportprodutionorders} icon="ri-inbox-archive-line" children={"Exportar a Excel Ordenes de Producción"} />
                </div>
            </div>

            <div className="col">


                <BasicTable
                    listButtons={listaBotones()}
                    head={head} body={lista}
                    rowSet={setRowBean}
                    iconButtons={iconButtonsItem}
                    pageTop={paginador.page}
                    next={paginador.next}
                    back={paginador.back}
                    records={paginador} />

                <Modal modal={exportexel} updateModal={setexportexel} eventModal={exportProductionOrders}>
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate label="Fecha Corte" name="date" value={date} setDate={(e: any) => { setDate(e) }} ></InputDate>
                            </div>
                            <div className="col-md-12"><SelectProductionOrderStateConstants idSelector={exportxsl} onChange={(e) => { setexportxsl(e) }} /></div>
                        </div>
                        <div className="row">

                            <div className="col-md-12">
                                {formatodos?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>

                                        <div className="col-md-6 mt-3">
                                            <a href={formatodos.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>{formatodos.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>

                    </>
                </Modal>

                <Modal modal={exportproductionordenbyaccion} updateModal={setexportproductionordenbyaccion}>
                    <>
                        <div className="row">
                            {/* <div className="col-md-6">
                                <BasicButton eventClick={exportProductionOrdersbyaccion} icon="ri-inbox-archive-line" children={"Exportar a Excel Ordenes de Producción"} />
                            </div> */}

                            <div className="col-md-12">
                                {formatotres?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formatotres.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>{formatotres.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>

                    </>
                </Modal>

                <Modal modal={modalticket} updateModal={setModalticket}>
                    <>
                        <div className="row">
                            {/* <div className="col-md-6">
                                <BasicButton eventClick={exportProductionOrdersbyaccion} icon="ri-inbox-archive-line" children={"Exportar a Excel Ordenes de Producción"} />
                            </div> */}

                            <div className="col-md-12">
                                {formatoticket?.DataBeanProperties?.URLLink && (
                                    // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                    <div className="row">
                                        <div className="col-md-12 mt-3">
                                            <label>Descarga en el Siguiente Link:*</label>
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <a href={formatoticket.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                <strong>📄 {formatoticket.DataBeanProperties.Filename}</strong>
                                            </a>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>

                    </>
                </Modal>

                <Modal modal={consultar} updateModal={setConsultar}>
                    <>
                        <RawMaterialRequestCatalog idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                    </>
                </Modal>
                <Modal modal={inventory} updateModal={setInventory}>
                    <>
                        <MaterialAvailableProductionOrder idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                    </>
                </Modal>
                <Modal modal={modalcost} updateModal={setModalcost}>
                    <>
                        <CostProductionOrderCatalog idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                    </>
                </Modal>


                <Modal modal={traslados} updateModal={setTraslados}>
                    <ProductionOrderRemission idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                </Modal>

                <Modal modal={modaltrasladoprocces} updateModal={setModaltrasladoprocces}>
                    <>
                        <TraslateProdcutProccesFinished idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                    </>

                </Modal>

                <Modal modal={modalregister} updateModal={setModalregister}>
                    <>
                        <OrderToWIP idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                    </>

                </Modal>

                <Modal modal={modallotes} updateModal={setModallotes}>
                    <>
                        <ProductLotCatalog IDProductionOrder={bean.IDProductionOrder} ProductionOrderDate={bean.ProductionOrderDate} />
                    </>

                </Modal>

                <Modal modal={modalverdocs} updateModal={setModalverdocs}>
                    <>
                        <ProductionOrderDocuments idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                    </>

                </Modal>

                <Modal modal={modaltime} updateModal={setModaltime}>
                    <>
                        <TimeMovements idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                    </>

                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar Informacion de {bean.IDProductiveProcessType} - {bean.Name}</strong>
                </ModalConfirm>

                <Modal modal={ejecutarorden} updateModal={setEjecutarorden} eventModal={ejecutarlaordendeproduccion} onSubmitLabel="Ejecutar Orden"  >
                    <div className="row">
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Observations" className="form-control" value={bean.Observations || ""} onChange={handleChange} />

                        </div>
                        {/* <div className="col-md-6 mt-3">
                            <BasicButton eventClick={ejecutarlaordendeproduccion} icon="ri-folder-upload-fill" >
                                Ejecutar Orden
                            </BasicButton>
                        </div> */}

                    </div>
                </Modal>

                <Modal modal={modalupdateestand} updateModal={setModalupdateestand} eventModal={updateProductionOrderStandardCostsImp} onSubmitLabel="Actualizar Costo Estandard del Estandard">
                    <div className="row">
                        <strong>Actualizar Costo Estandard  {bean.IDProductionOrder} - {bean.ProductionOrderDate}</strong>
                    </div>
                </Modal>

                <Modal modal={modalEvents.modal} updateModal={modalEvents.setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            <ProductionOrderEvent idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} />
                        </div>
                    </div>
                </Modal>


                <Modal modal={modaladdplan} updateModal={setModaladdplan} eventModal={applyProductionPlanToProductionOrder} onSubmitLabel="Agregar a Plan de Producción">
                    <div className="row">
                        <div className="col-md-12">
                            <label>Plan de Producción</label>
                            <ProductionPlanEditor render={applyprod.bean.ProductName} idSelector={applyprod.bean.IDProductionPlan} onChange={(e) => { applyprod.setBean({ ...applyprod.bean, "IDProductionPlan": e.IDProductionPlan, "ProductName": e.ProductName, "ProductionPlanDate": e.ProductionPlanDate }) }} label=" " returnType="Object" />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modaldeleteplan} updateModal={setModaldeleteplan} eventModal={releaseProductionOrderFromProductionPlan}>
                    <strong>Eliminar de Plan de Producción ?</strong>
                </ModalConfirm>

                <Modal modal={modalCancel.modal} updateModal={modalCancel.setModal} eventModal={() => { cancelProductionOrder() }}>
                    <div className="row">
                        <div className="col">
                            <label>Observaciones</label>
                            <textarea value={formControl.Observations} onChange={(e) => { setFormControl({ ...formControl, Observations: e.target.value }) }} className="form-control"></textarea>
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalNullify.modal} updateModal={modalNullify.setModal} eventModal={() => { nullifyProductionOrder() }}>
                    <div className="row">
                        <div className="col">
                            <label>Observaciones</label>
                            <textarea value={formControl.Observations} onChange={(e) => { setFormControl({ ...formControl, Observations: e.target.value }) }} className="form-control"></textarea>
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalUpdateDates.modal} updateModal={modalUpdateDates.setModal} eventModal={() => { setRealDates() }}>
                    <div className="row">
                        <div className="col-md-6">
                            <InputDate name="" label="Fecha Inicial de Producción" value={formControl.FromDate} setDate={(e) => { setFormControl({ ...formControl, FromDate: e }) }} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="" label="Fecha Final de Producción" value={formControl.UptoDate} setDate={(e) => { setFormControl({ ...formControl, UptoDate: e }) }} />
                        </div>
                        <div className="col">
                            <label>Observaciones</label>
                            <textarea value={formControl.Observations} onChange={(e) => { setFormControl({ ...formControl, Observations: e.target.value }) }} className="form-control"></textarea>
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalmaquila} updateModal={setModalmaquila} eventModal={assignExternalFactoryToProductionOrder} onSubmitLabel="Asignar a Maquila/Centro de Fabricación Externo">
                    <div className="row">
                        <div className="col-md-12">
                            <label>Centro de Producción Externa/Maquila</label>
                            <ExternalFactoryEditor render={assingexternal.bean.NameExternal} idSelector={assingexternal.bean.IDExternalFactory} onChange={(e) => { assingexternal.setBean({ ...assingexternal.bean, "IDExternalFactory": e.IDExternalFactory, "NameExternal": e.Name }) }} label=" " returnType="Object" />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modaldeleteexternal} updateModal={setModaldeleteexternal} eventModal={releaseProductionOrderFromExternalFactory}>
                    <strong>Eliminar de Maquila/Centro de Fabricación Externo ?</strong>
                </ModalConfirm>

                <Modal modal={detenerorden} updateModal={setDetenerorden} eventModal={detenerordendeproduccion} onSubmitLabel="Detener Orden">
                    <div className="row">
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Observations" className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={finalizarorden} updateModal={setFinalizarorden} eventModal={finalizarordendeproduccion} onSubmitLabel="Finalizar Orden">
                    <div className="row">
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Observations" className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={costeoestandard} updateModal={setCosteoestandard} eventModal={createTimeEventStandardForProductionOrder} onSubmitLabel="Generar Contabilización de Costeo Estandard">
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate name="AccountantDate" value={TimeEventStandard.bean.AccountantDate} label="Fecha de Contabilización" setDate={(e) => { TimeEventStandard.setBean({ ...TimeEventStandard.bean, "AccountantDate": e }) }} />
                        </div>

                    </div>
                </Modal>

                <Modal modal={modalajustar} updateModal={setModalajustar} eventModal={createRawMaterialAdjustmentForProductionOrder} onSubmitLabel="Ajustar Costos de Material">
                    <div className="row">
                        <div className="col-md-6">
                            <InputDate name="AccountantDate" value={Ajustar.bean.AccountantDate} label="Fecha de Registro Contable" setDate={(e) => { Ajustar.setBean({ ...Ajustar.bean, "AccountantDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectStoreEditor label="Almacén Destino" idSelector={Ajustar.bean.IDStoreDestinity} onChange={(e) => { Ajustar.setBean({ ...Ajustar.bean, "IDStoreDestinity": e.IDStore }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Description" className="form-control" value={Ajustar.bean.Description} onChange={(e) => { Ajustar.setBean({ ...Ajustar.bean, 'Description': e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modaldevolucion} updateModal={setModaldevolucion} eventModal={createRawMaterialCloseForProductionOrder} onSubmitLabel=" Realizar Devolución de Materia Prima a Almacén">
                    <div className="row">
                        <div className="col-md-6">
                            <InputDate name="AccountantDate" value={Devolucion.bean.AccountantDate} label="Fecha de Registro Contable" setDate={(e) => { Devolucion.setBean({ ...Devolucion.bean, "AccountantDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectStoreEditor label="Almacén Destino" idSelector={Devolucion.bean.IDStoreDestinity} onChange={(e) => { Devolucion.setBean({ ...Devolucion.bean, "IDStoreDestinity": e.IDStore }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Description" className="form-control" value={Devolucion.bean.Description} onChange={(e) => { Devolucion.setBean({ ...Devolucion.bean, 'Description': e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalliquidar} updateModal={setModalliquidar} eventModal={liquidateProductionOrder} onSubmitLabel="Liquidar Orden de Producción">
                    <div className="row">
                        <div className="col-md-6">
                            <InputDate name="AccountantDate" value={liquidar.bean.AccountantDate} label="Fecha de Registro Contable" setDate={(e) => { liquidar.setBean({ ...liquidar.bean, "AccountantDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectStoreEditor label="Almacén Destino" idSelector={liquidar.bean.IDStoreDestinity} onChange={(e) => { liquidar.setBean({ ...liquidar.bean, "IDStoreDestinity": e.IDStore }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Description" className="form-control" value={liquidar.bean.Description} onChange={(e) => { liquidar.setBean({ ...liquidar.bean, 'Description': e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalDocliquidar} updateModal={setModalDocliquidar}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docsliquidation}
                                IDDocument={bean.IDDocument}
                                Since={bean.DocumentDate}
                            />
                        </div>
                    </div>
                </Modal>

                <Modal modal={ajustardocs} updateModal={setajustardocs}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docs}

                            />
                        </div>
                    </div>
                </Modal>

                <Modal modal={devoluciondocs} updateModal={setdevoluciondocs}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docsvdos}

                            />
                        </div>
                    </div>
                </Modal>

                <Modal modal={liquidardocs} updateModal={setliquidardocs}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docsvtres}

                            />
                        </div>
                    </div>
                </Modal>

                <Modal modal={standardsdocs} updateModal={setStandardsdocs}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docsvcinco}

                            />
                        </div>
                    </div>
                </Modal>

                <Modal modal={reporte} updateModal={setDescargarreporte}>
                    <div className="row">
                        {formato?.DataBeanProperties?.URLLink && (
                            // <PrintJson json={formato.DataBeanProperties.URLLink} />
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                        <strong>{formato.DataBeanProperties.Filename}</strong>
                                    </a>
                                </div>
                            </div>

                        )}



                    </div>
                </Modal>

                <Modal modal={modal} updateModal={setModal} eventModal={validateAddData}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFieldsAdd.includes('ProductionOrderDate') ? 'has-error' : ''}`}>Fecha de la Orden de Producción</label>
                            <InputDate name="date" value={bean.ProductionOrderDate} label=" " setDate={(e) => { setBean({ ...bean, "ProductionOrderDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFieldsAdd.includes('IDAttentionOffice') ? 'has-error' : ''}`}>Centro de Fabricación</label>
                            <SelectAttentionOffice idSelector={bean.IDAttentionOffice} onChange={(e) => { setBean({ ...bean, "IDAttentionOffice": e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFieldsAdd.includes('InitDate') ? 'has-error' : ''}`}>Fecha de Inicio Planeada</label>
                            <InputDate name="date" value={bean.InitDate} label=" " setDate={(e) => { setBean({ ...bean, "InitDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Fecha Finalización Planeada</label>
                            <InputDate name="date" value={bean.UptoDate} label=" " setDate={(e) => { setBean({ ...bean, "UptoDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label >Fecha Inicio Real</label>
                            <InputDate name="date" value={bean.RealInitDate} label=" " setDate={(e) => { setBean({ ...bean, "RealInitDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Fecha Finalización Real</label>
                            <InputDate name="date" value={bean.RealUptoDate} label=" " setDate={(e) => { setBean({ ...bean, "RealUptoDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFieldsAdd.includes('Type') ? 'has-error' : ''}`}>Tipo de Solitud</label>
                            <SelectProductionOrderRequestConstants idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label >Producto a Producir</label>
                            <SelectProductEditor renderValue={bean.ProductName} filterType={3} label=" " value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Variante/Talla de Producto</label>
                            <SelectProductVariant label=" " idProduct={bean.IDProduct} idSelector={bean.IDProductVariant} onChange={(e) => { setBean({ ...bean, "IDProductVariant": e }) }} />
                        </div>
                        <div className="col-md-6">
                            {/* <SelectManufacturingStandars label="Estandard de Fabricación" idSelector={bean.IDManufacturingStardard} onChange={(e) => { setBean({ ...bean, "IDManufacturingStardard": e }) }} /> */}
                            <ManufacturingStandarsEditor IDManufacturingStardard={bean.IDManufacturingStardard} returnData={(e) => { setBean({ ...bean, "IDManufacturingStardard": e.IDManufacturingStardard }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Rutas de Producción</label>
                            <SelectProductionRoute render={bean.ProductionRouteName} idSelector={bean.IDProductionRoute} onChange={(e) => { setBean({ ...bean, "IDProductionRoute": e.IDProductionRoute, "ProductionRouteName": e.Name }) }} label=" " returnType="Object" />
                            {/* <ProductionRouteSelect idSelector={bean.IDProductionRoute} label="Ruteo de Producción" onChange={(e) => { setBean({ ...bean, "IDProductionRoute": e }) }} /> */}
                        </div>
                        {/* <div className="col-md-6">
                            <label>Código Orden de Producción</label>
                            <input type="number" name="Code" className="form-control" value={bean.Code} onChange={handleChange} />
                        </div> */}
                        <div className="col-md-6">
                            <label>No Solicitud Cliente</label>
                            <input type="number" name="ExternalRequestReference" className="form-control" value={bean.ExternalRequestReference} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <SelectBusinessCore label='Línea de Negocio' returnType="Object" idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e.IDBusinessCore }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFieldsAdd.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                            <SelectProject idSelector={bean.IDProject} onChange={(e) => { setBean({ ...bean, "IDProject": e }) }} label=" " />
                        </div>
                        {/* <div className="col-md-6">
                            <label className={`${missingFieldsAdd.includes('IDAccount') ? 'has-error' : ''}`}>Cliente Final</label>
                            <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                        </div> */}
                        {/* <div className="col-md-6">
                            <label className={`${missingFieldsAdd.includes('IDAccount') ? 'has-error' : ''}`}>Cliente Final</label>
                            <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                        </div> */}
                        <div className="col-md-6">
                            <label className={`${missingFieldsAdd.includes('Quantity') ? 'has-error' : ''}`}>Cantidad a Producir</label>
                            <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={handleChange} />
                        </div>
                        <div className="col-md-12">
                            <label>Observaciones</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, 'Description': e.target.value }) }} />
                        </div>
                    </div>
                    {/* <PrintJson json={bean} /> */}
                </Modal>
            </div>

        </div>
    );

    return isModal ? rowContent : (
        <BasicPage titulo="Ordenes de Producción">
            {rowContent}
        </BasicPage>
    );
}



